<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper" ref="sidebar">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <li
                    v-bind:class="{'active': menu.isActive}"
                    v-for="(menu, m_index) in menuArray"
                    :id="menu.id"
                    :ref="menu.ref"
                    v-bind:key="'menu-'+m_index"
            >
                <router-link v-bind:to="menu.routerlink">
          <span class="fa-stack fa-lg pull-left">
            <i :class="menu.icon"></i>
          </span>
                    {{ menu.name }}
                </router-link>
            </li>
        </ul>
    </div>
    <!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    var self;

    export default {
        name: 'Sidebar',
        mixins: [commonMixins],
        components: {

        },
        data() {
            return {
                menuArray: [
                    // {
                    //     name: "Dashboard",
                    //     isActive: true,
                    //     ref: "dashboard",
                    //     id: "dash-board",
                    //     routerlink: {
                    //         name: "Dashboard"
                    //     },
                    //     icon: "fa fa-th fa-stack-1x"
                    // },
                    // {
                    //     name: "Users",
                    //     isActive: false,
                    //     ref: "listuser",
                    //     id: "listuser",
                    //     routerlink: {
                    //         name: "ListUser"
                    //     },
                    //     icon: "fa fa-users fa-stack-1x"
                    // },
                    {
                        name: "GL Export",
                        isActive: false,
                        ref: "glexport",
                        id: "glexport",
                        routerlink: {
                            name: "GLExport"
                        },
                        icon: "fa fa-users fa-stack-1x"
                    },
                    {
                        name: "Email Manager",
                        isActive: false,
                        ref: "email-manager",
                        id: "email-manager",
                        routerlink: {
                            name: "EmailManager"
                        },
                        icon: "fa fa-users fa-stack-1x"
                    },
                    {
                        name: "Top Facility Export",
                        isActive: false,
                        ref: "top-facility-export",
                        id: "top-facility-export",
                        routerlink: {
                            name: "TopFacilityExport"
                        },
                        icon: "fa fa-users fa-stack-1x"
                    },
                    {
                        name: "Top Facility Email Manager",
                        isActive: false,
                        ref: "training-email-manager",
                        id: "training-email-manager",
                        routerlink: {
                            name: "ListTrainingEmailManager"
                        },
                        icon: "fa fa-users fa-stack-1x"
                    },
                    {
                        name: "Location Manager",
                        isActive: false,
                        ref: "location-manager",
                        id: "location-manager",
                        routerlink: {
                            name: "LocationManager"
                        },
                        icon: "fa fa-users fa-stack-1x"
                    },
                    {
                        name: "Department Manager",
                        isActive: false,
                        ref: "department-manager",
                        id: "department-manager",
                        routerlink: {
                            name: "DepartmentManager"
                        },
                        icon: "fa fa-users fa-stack-1x"
                    },
                    // {
                    //     name: "Test",
                    //     isActive: false,
                    //     ref: "test",
                    //     id: "test",
                    //     routerlink: {
                    //         name: "Test"
                    //     },
                    //     icon: "fa fa-users fa-stack-1x"
                    // },
                ]
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            $("#menu-toggle").click(function(e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function(e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $("#menu ul").hide();
            });

            $(".tree-toggle").click(function() {
                $(this)
                    .parent()
                    .children("ul.tree")
                    .toggle(200);
            });



            /*$("#menu-toggle").on("click", function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").on("click", function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                /!*$('ul.tree').hide();*!/
                $(this).parent().children('ul.tree').toggle(200);
                if ($(this).children().eq(1).attr('class').indexOf('fa-angle-down') != -1) {
                    $(this).children().eq(1).addClass('fa-angle-up');
                    $(this).children().eq(1).removeClass('fa-angle-down');
                } else {
                    $(this).children().eq(1).removeClass('fa-angle-up');
                    $(this).children().eq(1).addClass('fa-angle-down');
                }
            });*/

        },
        methods: {
            getActiveMenu :function () {
                console.log("called");
            } ,

            initMenu: function () {
                $('#menu ul').hide();
                $('#menu ul').children('.current').parent().show();
                //$('#menu ul:first').show();
                $('#menu li a').click(
                    function () {
                        var checkElement = $(this).next();
                        if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                            return false;
                        }
                        if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                            $('#menu ul:visible').slideUp('normal');
                            checkElement.slideDown('normal');
                            return false;
                        }
                    }
                );
            },
        }
    }


    EventBus.$on("menu-selection-changed", function(menuref) {
        if (typeof self != "undefined") {
            for (var i = 0; i < self.menuArray.length; i++) {
                var menuObject = self.menuArray[i];
                if (menuref == menuObject.ref) {
                    menuObject.isActive = true;
                } else {
                    menuObject.isActive = false;
                }
            }
            //console.log(self.$refs[menuref][0].classList);
            //self.$refs[menuref][0].classList.remove('active');
        }
    });
</script>




// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue